import { ReportType } from '../statements/types';

export enum FilterTypes {
  UpdateFilter = '@filter/UPDATE_FILTER',
}

export type FilterKeyOptions = 'today' | 'last-30-days' | 'customized-period';

export interface FilterState {
  filterKey?: FilterKeyOptions;
  periodStart?: Date;
  periodEnd?: Date;
  reportType?: ReportType;
  isFirstLoad?: boolean;
  document?: string;
}
